module.exports = __webpack_public_path__ + "static/img/MvpBg.61ef0bbb.png";